// extracted by mini-css-extract-plugin
export default {"table":"Transactions_table__okeH+","head":"Transactions_head__ynuBp","body":"Transactions_body__Q3nG1","row":"Transactions_row__OrL+q"};